/*
 * Copyright 2024 Mifos Initiative
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/openMF/mobile-wallet/blob/master/LICENSE.md
 */
package org.mifospay.feature.payments

import androidx.navigation.NavController
import androidx.navigation.NavGraphBuilder
import androidx.navigation.NavOptions
import androidx.navigation.compose.composable
import org.mifospay.core.ui.utility.TabContent

const val PAYMENTS_ROUTE = "payments_route"

fun NavController.navigateToPayments(navOptions: NavOptions) = navigate(PAYMENTS_ROUTE, navOptions)

fun NavGraphBuilder.paymentsScreen(
    tabContents: List<TabContent>,
) {
    composable(route = PAYMENTS_ROUTE) {
        PaymentsRoute(tabContents = tabContents)
    }
}
